import { waitAsync } from '../utils';
import { Route } from 'react-router-dom';

const ListPayOffListAction = "LIST_PAYOFF_LISTS";
const ListPayOffListDailyAction = "LIST_PAYOFF_LISTS_DAILY";
const ListPayOffListDetailAction = "LIST_PAYOFF_LISTS_DETAIL";
const ListPayOffListElapseAction = "LIST_PAYOFF_LISTS_ELAPSE";
const ListPayOffListCarryOverAction = "LIST_PAYOFF_LISTS_CARRYOVER";
const DownloadExternalLinkedCsv = "DOWNLOAD_EXTERNAL_LINKED_CSV";
const Waiting = "WAITING";

const initialState = {
    list: [],
    listDaily: [],
    listDetail: [],
    listElapse: [],
    listCarryOver: [],
    csvInfo: [],
    nowWainting: false,
};
export const actionCreators = {
    /**
     * 精算一覧リストを取得します。
     */
    listPayOffLists: (token, nengetsu, fixedDt, merchantType) => async (dispatch) => {
        const routeurl = `api/user/payOffLists/list`;

        var param = `?nengetsu=${nengetsu}&fixedDt=${fixedDt}`;
        if (merchantType != "" && merchantType != null && merchantType != undefined) {
            param += `&merchantType=${merchantType}`;
        }

        dispatch({ type: Waiting, nowWainting: true });

        try {

            let response = await fetch(routeurl + param, {
                method: 'get',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
            })

            const resultStatus = response.status;

            if (resultStatus == 200) {
                const list = await response.json();
                dispatch({ type: ListPayOffListAction, list });
                return list;
            } else {
                throw new Error('精算リストの取得に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * 精算日別リストを取得します。
     */
    listPayOffListsDaily: (token, nengetsu, fixedDt, merchantType, merchantId) => async (dispatch) => {
        const routeurl = `api/user/payOffLists/list_daily`;

        var param = `?nengetsu=${nengetsu}&fixedDt=${fixedDt}&merchantType=${merchantType}&merchantId=${merchantId}`;

        dispatch({ type: Waiting, nowWainting: true });

        try {

            let response = await fetch(routeurl + param, {
                method: 'get',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
            })

            const resultStatus = response.status;

            if (resultStatus == 200) {
                const listDaily = await response.json();
                dispatch({ type: ListPayOffListDailyAction, listDaily: listDaily });
                return listDaily;
            } else {
                throw new Error('精算日別リストの取得に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * 精算詳細リストを取得します。
     */
    listPayOffListsDetail: (token, nengetsu, fixedDt, merchantType, merchantId, nengappi) => async (dispatch) => {
        const routeurl = `api/user/payOffLists/list_detail`;

        var param = `?nengetsu=${nengetsu}&fixedDt=${fixedDt}&merchantType=${merchantType}&merchantId=${merchantId}&nengappi=${nengappi}`;

        dispatch({ type: Waiting, nowWainting: true });

        try {

            let response = await fetch(routeurl + param, {
                method: 'get',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
            })

            const resultStatus = response.status;

            if (resultStatus == 200) {
                const listDetail = await response.json();
                dispatch({ type: ListPayOffListDetailAction, listDetail: listDetail });
                return listDetail;
            } else {
                throw new Error('精算詳細リストの取得に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * 精算未了（過去分）リストを取得します。
     */
    listPayOffListsElapse: (token, nengetsu, fixedDt, merchantType, merchantId) => async (dispatch) => {
        const routeurl = `api/user/payOffLists/list_elapse`;

        var param = `?nengetsu=${nengetsu}&fixedDt=${fixedDt}&merchantType=${merchantType}&merchantId=${merchantId}`;

        dispatch({ type: Waiting, nowWainting: true });

        try {

            let response = await fetch(routeurl + param, {
                method: 'get',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
            })

            const resultStatus = response.status;

            if (resultStatus == 200) {
                const listElapse = await response.json();
                dispatch({ type: ListPayOffListElapseAction, listElapse: listElapse });
                return listElapse;
            } else {
                throw new Error('精算未了（過去分）リストの取得に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * 精算未了（繰越分）リストを取得します。
     */
    listPayOffListsCarryOver: (token, nengetsu, fixedDt, merchantType, merchantId) => async (dispatch) => {
        const routeurl = `api/user/payOffLists/list_carryover`;

        var param = `?nengetsu=${nengetsu}&fixedDt=${fixedDt}&merchantType=${merchantType}&merchantId=${merchantId}`;

        dispatch({ type: Waiting, nowWainting: true });

        try {

            let response = await fetch(routeurl + param, {
                method: 'get',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
            })

            const resultStatus = response.status;

            if (resultStatus == 200) {
                const listCarryOver = await response.json();
                dispatch({ type: ListPayOffListCarryOverAction, listCarryOver: listCarryOver });
                return listCarryOver;
            } else {
                throw new Error('精算未了（繰越分）リストの取得に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * 一覧を初期化します。
     */
    initListInfo: () => async (dispatch) => {
        dispatch({ type: ListPayOffListAction, list: [], nowWainting: false });
    },

    /**
     * 外部連携CSVファイルを取得します。
     */
    downloadExternalLinkedCsv: (token, nengetsu, fixedDt, merchantType) => async (dispatch) => {
        const routeurl = `api/user/payOffLists/download`;

        var param = `?nengetsu=${nengetsu}&fixedDt=${fixedDt}`;
        if (merchantType != "" && merchantType != null && merchantType != undefined) {
            param += `&merchantType=${merchantType}`;
        }

        dispatch({ type: Waiting, nowWainting: true });

        try {

            let response = await fetch(routeurl + param, {
                method: 'get',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
            })

            const resultStatus = response.status;

            if (resultStatus == 200) {
                const csvInfo = await response.json();
                dispatch({ type: DownloadExternalLinkedCsv, csvInfo });
                return csvInfo;
            } else {
                throw new Error('精算リストの取得に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },}

export const reducer = (state, action) => {
    state = state || initialState;
    
    if (action.type === Waiting) {
        return {
            ...state,
            nowWainting: action.nowWainting
        };
    }
    if (action.type === ListPayOffListAction) {
        return {
            ...state,
            list: action.list,
            nowWainting: action.nowWainting
        };
    }
    if (action.type === ListPayOffListDailyAction) {
        return {
            ...state,
            listDaily: action.listDaily,
            nowWainting: action.nowWainting
        };
    }
    if (action.type === ListPayOffListDetailAction) {
        return {
            ...state,
            listDetail: action.listDetail,
            nowWainting: action.nowWainting
        };
    }
    if (action.type === ListPayOffListElapseAction) {
        return {
            ...state,
            listElapse: action.listElapse,
            nowWainting: action.nowWainting
        };
    }
    if (action.type === ListPayOffListCarryOverAction) {
        return {
            ...state,
            listCarryOver: action.listCarryOver,
            nowWainting: action.nowWainting
        };
    }
    if (action.type === DownloadExternalLinkedCsv) {
        return {
            ...state,
            csvInfo: action.csvInfo,
            nowWainting: action.nowWainting
        };
    }
   return state;
}